'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactNumberFormat = require('react-number-format');

var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);

var _reactCssComponent = require('react-css-component');

var _Confirmed = require('../UI/Confirmed');

var _Confirmed2 = _interopRequireDefault(_Confirmed);

var _Projected = require('../UI/Projected');

var _Projected2 = _interopRequireDefault(_Projected);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = '\n.display-table-row {\n  display: table-row;\n}\n.display-table-cell {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.roster-position-small {\n  height: 30px;\n  line-height: 30px;\n  position: relative;\n  z-index: 1;\n  background-color: #fff;\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n.roster-position-font-small {\n  position: absolute;\n  top: 0;\n  font-size: 44px;\n  color: #eaeaea;\n  font-weight: bold;\n  height: 34px;\n  line-height: 34px;\n  z-index: -1;\n  padding-left: 7px;\n}\n.border-bottom {\n  border-bottom: 1px solid #eaeaea;\n}\n';

var displayGroupName = function displayGroupName(group_name) {
    if (group_name === 'Pitchers') {
        return 'P';
    }
    return group_name;
};

var LineupCardRow = function LineupCardRow(props) {
    var playerOrder = null;
    var playerOrderConfirmed = false;
    var playerOrderProjected = false;
    if (props.player.values) {
        playerOrder = +props.player.values.lineup_order !== 0 ? props.player.values.lineup_order : null;
        playerOrderConfirmed = props.player.values.confirmed === 'Y' ? true : false;
        playerOrderProjected = props.player.values.confirmed === 'N' ? true : false;
    }

    var rosterPositionDisplay = '';
    if (props.sport === 'mlb') {
        rosterPositionDisplay = _react2.default.createElement(
            'div',
            { className: 'display-table-row roster-position-small' },
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell border-bottom no-wrap', style: { zIndex: '1' } },
                _react2.default.createElement(
                    'div',
                    { className: 'roster-position-font-small' },
                    displayGroupName(props.pos)
                ),
                props.player.player_name
            ),
            _react2.default.createElement(
                'div',
                {
                    className: 'display-table-cell border-bottom center',
                    style: { zIndex: '2', backgroundColor: '#fff' }
                },
                props.player.values ? _react2.default.createElement('img', {
                    src: 'https://media.fantasylabs.com/assets/teams/' + props.player.values.team_id + '.gif',
                    onError: props.addDefaultSrc,
                    style: { width: '36px', height: '24px', marginRight: '5px' },
                    alt: props.player.values.team
                }) : ''
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell border-bottom center' },
                playerOrder,
                '\xA0',
                playerOrderConfirmed ? _react2.default.createElement(_Confirmed2.default, null) : '',
                playerOrderProjected && playerOrderConfirmed === false ? _react2.default.createElement(_Projected2.default, null) : ''
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell border-bottom center' },
                _react2.default.createElement(_reactNumberFormat2.default, {
                    value: props.player.values ? props.player.values.salary : 0,
                    displayType: 'text',
                    thousandSeparator: true,
                    prefix: '$'
                })
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell border-bottom center' },
                props.player.values && props.player.values.points !== null ? props.player.values.points.toFixed(2) : 0
            ),
            _react2.default.createElement(
                'div',
                { className: 'display-table-cell border-bottom center' },
                props.player.values && props.player.values.actual_points !== null ? props.player.values.actual_points.toFixed(2) : 0
            )
        );
    }
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_reactCssComponent.ClientStyle, { css: css }),
        rosterPositionDisplay,
        _react2.default.createElement('hr', { style: { padding: '0', margin: '0' } })
    );
};

exports.default = LineupCardRow;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/lineups/LineupCardRow.js
// module id = 849
// module chunks = 0